"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mainFrameStyle = void 0;
function mainFrameStyle() {
    return {
        position: "absolute",
        width: "1px",
        height: "1px",
        border: "none",
        overflow: "visible",
    };
}
exports.mainFrameStyle = mainFrameStyle;
//# sourceMappingURL=dom.js.map